import i18n from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
import en from './assets/translations/en.json';
import th from './assets/translations/th.json';
import vn from './assets/translations/vn.json';
import ar from './assets/translations/ar.json';
const resources ={
  en:{translation:en},
  th:{translation:th},
  vn:{translation:vn},
  ar:{translation:ar}
}
i18n
  .use(Backend)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    resources,
    lng: (sessionStorage.getItem("lang"))?sessionStorage.getItem("lang"):'ar',
    interpolation: {
      escapeValue: false, // not needed for react!!
    }
  });


export default i18n;